import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './features/auth/AuthProvider';
// A sorrend számít: az i18n előbb álljon fel, mint az első komponens.
import './i18n';
import './styles/tokens.css';
import './styles/app.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Hiányzik a #root elem az index.html-ből.');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
